var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('page',[_c('div',{class:["loading-page"]},[_c('base-container',[_c('div',{class:["describe"]},[_vm._v("默认大小")]),_c('cube-loading'),_c('div',{class:["describe"]},[_vm._v("36大小")]),_c('cube-loading',{attrs:{"size":(36)}}),_c('div',{class:["describe"]},[_vm._v("48大小")]),_c('cube-loading',{attrs:{"size":(48)}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }